<template>
  <tr>
    <td>
      <router-link :to="'/fleet/reservations/' + reservation.uuid">
        {{ reservation.reservationId }}
      </router-link>
    </td>
    <td>
      <router-link v-if="showDriver" :to="{ path: `/membership/members/${reservation.Account.uuid}` }">
        {{ reservation.Account.dropdownLabel }}
      </router-link>
      <router-link v-else :to="'/fleet/vehicles/' + reservation.Car.uuid">
        {{ reservation.Car.dropdownLabel }}
      </router-link>
    </td>
    <td>
      {{ reservation.completedStartDate || reservation.startDate | date_format(reservation.Lot.timezone) }}
    </td>
    <td>
      {{ reservation.completedEndDate || reservation.endDate | date_format(reservation.Lot.timezone) }}
    </td>
    <td>
      <span :class="status.class" class="badge">
        {{ status.text }}
      </span>
    </td>
    <td>
      {{ reservation.actualCost || reservation.quotedCost | to_dollar_amount }}
    </td>
    <td>
      <dropdown-input label="Actions"
        label-icon="fa-calendar-alt"
        :is-small="true"
        :actions="reservationActions(reservation, loggedInUser)"
        :dropright="true"
        @action="executeAction($event, reservation)">
      </dropdown-input>
    </td>
  </tr>
</template>

<script>
import DropdownInput from '@/components/inputs/DropdownInput'
import moment from 'moment-timezone'
import { mapGetters, mapActions } from 'vuex'
import {
  ADD_RESERVATION_NOTE,
  CREATE_RESERVATION_CHARGE,
  EDIT_RESERVATION,
  CANCEL_RESERVATION,
  RESEND_RESERVATION,
  REFUND_RESERVATION,
  GENERATE_RESERVATION_INVOICE,
  SEND_CANCEL_MESSAGE
} from '@/vuex/types'

export default {
  components: {
    DropdownInput
  },
  name: 'ReservationRow',
  props: {
    object: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  computed: {
    showDriver () {
      return this.$route.path.includes('fleet')
    },
    status () {
      if (this.reservation.completed) {
        return { class: 'badge-success', text: 'Completed' }
      } else if (this.reservation.started) {
        return { class: 'badge-info', text: 'Started' }
      } else if (this.reservation.cancelled) {
        return { class: 'badge-danger', text: 'Cancelled' }
      } else if (moment(this.reservation.startDate).isAfter(moment())) {
        return { class: 'badge-amber', text: 'Upcoming' }
      } else {
        return { class: 'badge-default', text: 'Unused' }
      }
    },
    reservation () {
      return {
        started: false,
        completed: false,
        cancelled: false,
        refunded: false,
        reservationId: 0,
        Account: {},
        Car: {},
        Lot: {},
        DestinationLot: {},
        ...this.object,
        ...this.updatedReservation
      }
    },
    ...mapGetters([
      'reservationActions',
      'loggedInUser'
    ])
  },
  data () {
    return {
      updatedReservation: {}
    }
  },
  methods: {
    async executeAction (action, payload) {
      let result = await this[action](payload)
      if (result && result.updated) this.updatedReservation = result.updated
    },
    ...mapActions([
      CREATE_RESERVATION_CHARGE,
      ADD_RESERVATION_NOTE,
      RESEND_RESERVATION,
      EDIT_RESERVATION,
      CANCEL_RESERVATION,
      REFUND_RESERVATION,
      GENERATE_RESERVATION_INVOICE,
      SEND_CANCEL_MESSAGE
    ])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/rows/UserReservation.vue